import { render, staticRenderFns } from "./HeadBlock.vue?vue&type=template&id=51e713b2&"
import script from "./HeadBlock.vue?vue&type=script&lang=js&"
export * from "./HeadBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51e713b2', component.options)
    } else {
      api.reload('51e713b2', component.options)
    }
    module.hot.accept("./HeadBlock.vue?vue&type=template&id=51e713b2&", function () {
      api.rerender('51e713b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Partials/HeadBlock.vue"
export default component.exports